import type { paths } from '@orlikfy/api-interfaces';

export { UserRankDto } from '@orlikfy/api-interfaces';

// GET /user/{userId}/activity-rank
export const GET_USER_RANK_PATH = '/user/{userId}/activity-rank' as const satisfies keyof paths;
type GetUserRankOperation = paths[typeof GET_USER_RANK_PATH]['get'];
export type GetUserRankPathParams = GetUserRankOperation['parameters']['path'];
export type GetUserRankResponse = GetUserRankOperation['responses'][200]['content']['application/json'];

// GET /activity-rank/top
export const GET_USERS_TOP_RANK_PATH = '/activity-rank/top' as const satisfies keyof paths;
type GetUsersTopRankOperation = paths[typeof GET_USERS_TOP_RANK_PATH]['get'];
export type GetUsersTopRankResponse = GetUsersTopRankOperation['responses'][200]['content']['application/json'];
